// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__225-z","row":"ProcedureTreatmentSummary_row__sopUd"};